import React from "react";
import { Box, CircularProgress } from "@mui/material";

/// whole screen loading indication
const LoadingScreen: React.FC = () => (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "100vh" }}>
        <CircularProgress size={60} thickness={4} />
    </Box>
);

export default LoadingScreen;
